<div [hidden]="!tabSelected">
  <ng-content></ng-content>
</div>
